<template>
    <!-- Modal -->
    <div class="modal fade" ref="modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" :class="`modal-${size || 'lg'}`" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ title }}</h5>
                    <button v-if="buttonClose" type="button" class="btn btn-clean btn-icon btn-sm" @click="hideModal">
                        <span class="fa fa-fw fa-times"></span>
                    </button>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
                <div v-if="$slots.footer" class="modal-footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['title', 'buttonClose', 'show', 'size'],
    watch: {
        show(newVal, oldVal) {
            if(newVal) {
                this.showModal();
            }else {
                this.hideModal();
            }
        }
    },
    mounted() {
        let vm = this;
        
        $(vm.$refs.modal).on('hidden.bs.modal', function (e) {
            vm.$emit('close');
        })

        if(vm.show) vm.showModal();
    },
    beforeDestroy() {
        this.hideModal();
    },
    methods: {
        showModal() {
            $(this.$refs.modal).modal('show');
            console.log('abrinedo modal');
            document.querySelector('body').style.overflow = 'hidden';
            
            // $("body").css({
            //     'overflow': 'hidden'
            // });
        },
        hideModal() {
            $(this.$refs.modal).modal('hide');
            $("body").css({
                'overflow': 'auto'
            });
        }
    }
}
</script>